<template>
  <v-row>
    <v-col cols="7" class="mx-n4">
      <v-card-title>Redirection</v-card-title>
    </v-col>
    <v-col cols="10" class="mt-n8">
      <v-text-field
        v-model="actionValue.page"
        label="Entrer une url relative"
        color="blue"
        autocomplete="off"
        clearable
        item-color="info"
        menu-props="light"
        :rules="[isValidPageURL]"
      />
    </v-col>
  </v-row>
</template>
<script setup>

import { ref, computed } from 'vue';

const props = defineProps({
  action: { type: Object, required: true },
  workspaces: { type: Array, default: null }
});

const actionValue = ref(props.action);

const isValidRedirectionURL = computed(() => {
  if (!actionValue.value.url || /^\s*$/.test(actionValue.value.url)) {
    return 'Required';
  }

  const absoluteUrlregex = /(http|ftp|https):\/\/[\w-]+(\.[\w-]+)+([\w.,@?^=%&amp;:\/~+#-]*[\w@?^=%&amp;\/~+#-])?/;
  if (!absoluteUrlregex.test(actionValue.value.url)) {
    return 'Entrer une url absolute (ex: https://www.ucpa.com/sejour/SFAVALR10-velo-de-route-en-maurienne-vacances)';
  }
  return true;
});

const isValidPageURL = computed(() => {
  if (isValidRedirectionURL.value === true && (/^\s*$/.test(actionValue.value.page) || !actionValue.value.page)) {
    return true;
  }

  if (!actionValue.value.page || /^\s*$/.test(actionValue.value.page)) {
    return 'Required';
  }

  const relativeUrlRegex = /^(?:\/\/|[^\/]+)*\//;
  if (!relativeUrlRegex.test(actionValue.value.page)) {
    return 'Entrer une url relative (ex: /sejour/SFAVALR10-velo-de-route-en-maurienne-vacances)';
  }

  return true;
});

</script>

<style>
  #disabledRedirectionPageMessage{
    padding: 5px;
    font-weight: bold ;
  }
</style>
